<div class="basket-subscribe-save-banner" (click)="handleClick()">
  <button type="button">
    {{ title | i18next }}
  </button>
  <span class="text">
    {{ text | i18next }}
  </span>
  <span class="old-price">
    {{ currentPrice | currency }}
  </span>
  <span class="save-price">
    {{ savePrice | currency }}
  </span>
</div>
